import { Actions } from "../constant";

export const setServers = (servers) => ({ type: Actions.SET_SERVERS, servers });
export const addServer = (server) => ({ type: Actions.ADD_SERVER, server });
export const deploying = (ip) => ({ type: Actions.DEPLOYING, ip });
export const deployed = (ip) => ({ type: Actions.DEPLOYED, ip });
